"use client";

import {useEffect} from "react";
import {sendGTMEvent} from "@next/third-parties/google";

const DataLayer = ({data}) => {

    useEffect(() => {
            //if(!gtag) return null;
            try {
                //gtag(...data);
                sendGTMEvent(data);
                //dataLayer.push(data);
                //console.log('view_item');
            } catch (e) {
                console.log(e);
            }
    }, []);

    return <></>;

}

DataLayer.displayName = "DataLayer";

export default DataLayer;